// src/components/auth/ProtectedRoute.js
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { ROLES } from "../../config/supabase";
import { CircularProgress, Box } from "@mui/material";

const ProtectedRoute = ({
	children,
	allowedRoles = [],
	requireActiveProfile = false,
}) => {
	const { user, loading } = useAuth();
	const location = useLocation();

	if (loading) {
		return (
			<Box
				display="flex"
				justifyContent="center"
				alignItems="center"
				minHeight="100vh">
				<CircularProgress size={24} />
			</Box>
		);
	}

	if (!user) {
		return <Navigate to="/login" state={{ from: location }} replace />;
	}

	if (allowedRoles.length > 0 && !allowedRoles.includes(user?.profile?.role)) {
		return <Navigate to="/dashboard" replace />;
	}

	// Teachers only: block until profiles.status is Active (admins/other roles are unchanged)
	if (requireActiveProfile && user?.profile?.role === ROLES.SCHOOL_TEACHER) {
		if (!user.profile || user.profile.status !== "Active") {
			return <Navigate to="/dashboard" replace />;
		}
	}

	return children;
};

export default ProtectedRoute;
